import { StatisticsFilters } from './types';

export const DEFAULT_FILTERS: StatisticsFilters = {
  search: '',
  dateRange: 'all',
  grouping: 'day',
  account: 'all',
  campaign: 'all',
  models: [],
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

export const TABLE_COLUMNS = [
  { key: 'period', name: 'Period' },
  { key: 'subscribers', name: 'Subscribers' },
  { key: 'income', name: 'Income' },
];

export const getTableColumns = (t: (key: string) => string) => [
  { key: 'period', name: t('statistics.table.columns.period') },
  { key: 'subscribers', name: t('statistics.table.columns.subscribers') },
  { key: 'income', name: t('statistics.table.columns.income') },
];
